module.exports = __webpack_public_path__ + "img/banner.286bc711.png";